import React from "react";
import InvalidFeedback from "../InvalidFeedback";

export default React.forwardRef(({ label, value, counter, errors, ...register }: any, ref) => (
    <>
        {label && <label className="form-label" >{label}</label>}
        <textarea ref={ref} className={'form-control form-control-lg ' + (errors ? 'is-invalid' : '')} {...register} rows={5}/>
        
        <InvalidFeedback error={errors} />

        {
            counter && counter > 0 ? (<div className="form-text mt-1 text-end">{value}/{counter}</div>) : null
        }
        
    </>
))